import * as React from "react";
import { connect } from "react-redux";
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import StaticHtmlContent from "../common/staticHtmlContent";

class ScheduleBannerMsg extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.ScheduleBannerMsg.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { scheduleBannerMsgContent } = this.props;

        return (<React.Fragment> {scheduleBannerMsgContent &&
            <div className="row schedule-banner-msg-container">
                <div className="col-12 maxWidth-content">
                    <StaticHtmlContent content={scheduleBannerMsgContent} />
                </div>
            </div>
        }</React.Fragment>);
    }

}
const mapStateToProps = (state) => {
    const { scheduleBannerMsgContent } = state.session.serverData;
    return {
        scheduleBannerMsgContent: scheduleBannerMsgContent ? scheduleBannerMsgContent : ""
    };
};

export default connect(mapStateToProps, null)(ScheduleBannerMsg);
